var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tag-item",class:{
  'active': _vm.isActive
},on:{"click":function($event){return _vm.$emit('onAnswerClick', _vm.answer)}}},[_vm._v(_vm._s(_vm.name))])}
var staticRenderFns = []

export { render, staticRenderFns }